// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"2fb341a5","484":"71fe0aeb","551":"172b9290","672":"c0b9864f","842":"3ef2c199","869":"21f834fd","917":"60e4914f","974":"62e9ef93"}[chunkId] + ".chunk.js";
};